export { ModalBackdropComponent, ModalBackdropOptions } from './modal-backdrop.component';
export { ModalOptions } from './modal-options.class';
export { ModalDirective } from './modal.component';
export { ModalModule } from './modal.module';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
